import { createFileRoute } from '@tanstack/react-router';
import { useUser, useClerk } from '@clerk/clerk-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserIcon, SettingsIcon } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/settings/account')({
  component: AccountSettingsPage,
});

function AccountSettingsPage() {
  const { user } = useUser();
  const clerk = useClerk();

  const handleManageProfile = () => {
    if (clerk) {
      clerk.openUserProfile();
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold">Account Settings</h2>
        <p className="text-gray-600 mt-2">Manage your account settings</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <UserIcon className="w-5 h-5" />
            <span>Profile Information</span>
          </CardTitle>
          <CardDescription>Your account profile details</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleManageProfile}
                  type="button"
                >
                  <SettingsIcon className="w-4 h-4 mr-2" />
                  Manage Profile
                </Button>
              </div>
              <p className="text-gray-900">{user?.primaryEmailAddress?.emailAddress}</p>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name
              </label>
              <p className="text-gray-900">
                {user?.firstName || ''} {user?.lastName || ''}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

